import { z } from 'zod/mini'

import { amount } from './fields'
import { nonEmptyString } from './non-empty-string'

/**
 * Event-level `trade_in_details` of the cart and checkout funnel events.
 * Built from the buyback offer, whose id and category fall back to `''`.
 */
export const tradeInDetailsSchema = z.strictObject({
  trade_in_id: z.string(),
  trade_in_item_category: z.string(),
  trade_in_price: amount(),
  // Market currency, always available
  trade_in_currency: nonEmptyString(),
})

/** `remove_from_cart` and `purchase_back_bone` also describe the traded-in item. */
export const detailedTradeInDetailsSchema = z.strictObject({
  ...tradeInDetailsSchema.shape,
  trade_in_item_brand: z.string(),
  trade_in_item_name: z.string(),
})
